import React from 'react';
import PropTypes from 'prop-types';
import { decl } from '@yandex-lego/i-bem-react';
import _copyright__dates from "./__dates/copyright__dates.react.js";

var CopyrightDates = _copyright__dates.applyDecls();

import _copyright__link from "./__link/copyright__link.react.js";

var CopyrightLink = _copyright__link.applyDecls();

import _iServices from "./../i-services/i-services.react.js";

var IServices = _iServices.applyDecls();

var i18n = function () {
    var core = require('bem-i18n');

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'ru' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'ru' : 'en' === 'ru') {
        return core().decl(require('./copyright.i18n/ru'))('copyright');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'en' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'en' : 'en' === 'en') {
        return core().decl(require('./copyright.i18n/en'))('copyright');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'be' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'be' : 'en' === 'be') {
        return core().decl(require('./copyright.i18n/be'))('copyright');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'id' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'id' : 'en' === 'id') {
        return core().decl(require('./copyright.i18n/id'))('copyright');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'kk' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'kk' : 'en' === 'kk') {
        return core().decl(require('./copyright.i18n/kk'))('copyright');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'tr' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'tr' : 'en' === 'tr') {
        return core().decl(require('./copyright.i18n/tr'))('copyright');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'tt' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'tt' : 'en' === 'tt') {
        return core().decl(require('./copyright.i18n/tt'))('copyright');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'uk' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'uk' : 'en' === 'uk') {
        return core().decl(require('./copyright.i18n/uk'))('copyright');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'uz' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'uz' : 'en' === 'uz') {
        return core().decl(require('./copyright.i18n/uz'))('copyright');
    }

    if (process.env.NODE_ENV === 'development') {
        process.env.BEM_LANG && console.error('No match of process.env.BEM_LANG { ' + process.env.BEM_LANG + ' } in provided langs: { ru, en, be, id, kk, tr, tt, uk, uz }');
        process.env.REACT_APP_BEM_LANG && console.error('No match of process.env.REACT_APP_BEM_LANG { ' + process.env.REACT_APP_BEM_LANG + ' } in provided langs: { ru, en, be, id, kk, tr, tt, uk, uz }');
    }

    return function () {};
}();

export default decl({
    block: 'copyright',
    content: function content() {
        var start = this.props.start;


        return ['\xA9\xA0', // &nbsp;
        React.createElement(CopyrightDates, { start: start, key: 'date-' + start }), '\xA0\xA0', this.props.children || this.wrapLink(this.props, 'copyright-link-' + start)];
    },
    wrapLink: function wrapLink(_ref, key) {
        var url = _ref.url,
            elemLinkMix = _ref.elemLinkMix,
            contentRegion = _ref.contentRegion;

        var serviceUrl = IServices.serviceUrl('www', contentRegion);
        var copyrightText = i18n('yandex');
        var copyright = function copyright(content) {
            return i18n('link', { content: content });
        };

        url = url === undefined ? serviceUrl : url;

        return url ? copyright(React.createElement(
            CopyrightLink,
            {
                key: key,
                mix: elemLinkMix,
                url: url },
            copyrightText
        )) : copyright(copyrightText);
    }
}, {
    propTypes: {
        contentRegion: PropTypes.string
    },
    defaultProps: {
        contentRegion: 'ru'
    }
});